import proxy from "../proxy";
const publicApi = {
  getHomeData: (data, history) => async (dispatch) =>
    await proxy.get("public/homePage", data, { history, dispatch }),
  getFaqList: (data, history) => async (dispatch) =>
    await proxy.get("faq/list", data, { history, dispatch }),
  setFaqActive: (data) => async (dispatch) =>
    await dispatch({ type: "public/faq/activate", data: data }),
  searchFaq: (data) => async (dispatch) =>
    await dispatch({ type: "public/faq/search", data: data }),
  getContactData:
    (data = {}, history) =>
    async (dispatch) =>
      await proxy.get("public/contact", data, { history, dispatch }),
  getArList: (data, history) => async (dispatch) =>
    await proxy.get("public/ar", data, { history, dispatch }),
  getBlogList: (data, history) => async (dispatch) =>
    await proxy.get("public/blogList", data, { history, dispatch }),
  getBlogInfo: (data, history) => async (dispatch) =>
    await proxy.get("public/blogInfo", data, { history, dispatch }),
  filterNewProducts: (data, history) => async (dispatch) =>
    await dispatch({ type: "public/filter", data }),
  getProvince: (data, history) => async (dispatch) =>
    await proxy.get("public/province", data, { history, dispatch }),
  getCity: (data, history) => async (dispatch) =>
    await proxy.get("public/city", data, { history, dispatch }),
};

export default publicApi;
